/* eslint-disable no-param-reassign */

import { Action } from '@reduxjs/toolkit';

import type { ProjectsAction } from 'src/actions/projects/actionCreators';
import { ProjectsActionType } from 'src/actions/projects/actionTypes';

export const actionSanitizer = <A extends Action>(action: A) => {
  let typedAction = action as unknown as ProjectsAction;
  switch (typedAction.type) {
    case ProjectsActionType.UPDATED_PROJECT_DIAGRAM: {
      typedAction = {
        ...typedAction,
        payload: {
          ...typedAction.payload,
          diagram: {
            id: 'redacted for user experience',
            model: null as any,
          },
        },
      };
      break;
    }

    default: {
      // do nothing
    }
  }

  return action;
};
